import * as React from 'react'
import { BaseIconProps } from '../../../types'

function SvgWechat({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 10c3.314 0 6 2.239 6 5 0 1.668-.98 3.145-2.486 4.053L20 21l-1.95-1.3c-.64.194-1.33.3-2.05.3-3.314 0-6-2.239-6-5s2.686-5 6-5zM9 4c3.469 0 6.348 2.163 6.903 5.001L16 9c-3.866 0-7 2.686-7 6 0 .34.033.674.097.999L9 16a8.091 8.091 0 01-2.001-.249L4 18l.8-3.2C3.1 13.707 2 11.963 2 10c0-3.314 3.134-6 7-6zm5 8a1 1 0 100 2 1 1 0 000-2zm4 0a1 1 0 100 2 1 1 0 000-2zM6 7a1 1 0 100 2 1 1 0 000-2zm5 0a1 1 0 100 2 1 1 0 000-2z"
        fill={color}
      />
    </svg>
  )
}

export default SvgWechat
